import { render, staticRenderFns } from "./Barniz.vue?vue&type=template&id=91a3ec2a&"
import script from "./Barniz.vue?vue&type=script&lang=js&"
export * from "./Barniz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports